import React from "react";
import History from "./history.js";
import Chart from "./chart.js";
import {
  getMostRecentMarketDate,
  getMarketCalendar,
  isMarketOpenOnDate,
  getTimezoneDiffWithEST,
  getEndOfDayInNewYork,
} from "./utils.js";
import "./combined-live-view.css";

export default class CombinedHistoryView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null,
      marketCalendar: {},
      initComplete: false,
    };
  }

  componentDidMount() {
    getMarketCalendar().then(res => {
      const initialDate = getMostRecentMarketDate(res);
      this.setState({
        marketCalendar: res,
        selectedDate: initialDate,
        initComplete: true,
      });
    }).catch(err => {
      this.setState({
        selectedDate: getMostRecentMarketDate(/* marketCalendar = */ {}),
        initComplete: true,
      });
    }).finally(() => {
      this.initEventListeners();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  initEventListeners() {
    window.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    const { selectedDate, marketCalendar } = this.state;
    if (!selectedDate) return;

    const currentDate = new Date(selectedDate);

    if (event.code === "Comma") {
      currentDate.setDate(currentDate.getDate() - 1);
      while (!isMarketOpenOnDate(marketCalendar, currentDate)) {
        currentDate.setDate(currentDate.getDate() - 1);
      }
      this.onDateChange(new Date(currentDate));
    } else if (event.code === "Period") {
      const mostRecentDate = getMostRecentMarketDate(marketCalendar);
      const maxDate = getEndOfDayInNewYork(new Date(mostRecentDate.getTime() - getTimezoneDiffWithEST()));

      const targetDate = new Date(currentDate);
      targetDate.setDate(targetDate.getDate() + 1);

      while (!isMarketOpenOnDate(marketCalendar, targetDate) && targetDate <= maxDate) {
        targetDate.setDate(targetDate.getDate() + 1);
      }

      if (targetDate <= maxDate) {
        this.onDateChange(targetDate);
      } else {
        console.log("Cannot advance: Market data for tomorrow is not yet available.");
      }
    }
  };

  onDateChange(date) {
    this.state.selectedDate = date;
    this.setState(this.state);
  }

  render() {
    const { initComplete, selectedDate, marketCalendar } = this.state;

    return initComplete && (
      <div className="combined-view">
        <div>
          <History
            selectedDate={selectedDate}
            onDateChangeCallback={(date) => this.onDateChange(date)}
            marketCalendar={marketCalendar}
          />
        </div>
        <div className="right-block">
          <History
            selectedDate={selectedDate}
            onDateChangeCallback={(date) => this.onDateChange(date)}
            isEnergy={true}
            marketCalendar={marketCalendar}
          />
        </div>
        <div className="right-block expanded chart-block">
          <Chart
            selectedDate={selectedDate}
            onDateChangeCallback={(date) => this.onDateChange(date)}
            marketCalendar={marketCalendar}
          />
        </div>
      </div>
    );
  }
}
